
import React, { useMemo, useState, useEffect } from 'react';
import { products, categories } from '../data/products';
import ProductCard from '../components/product/ProductCard';
import BuyNowModal from '../components/home/BuyNowModal';
import './Products.css';

const Products = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isBuyModalOpen, setIsBuyModalOpen] = useState(false);

  const filteredProducts = useMemo(() => {
    if (selectedCategory === 'All') {
      return products;
    }

    return products.filter((product) => product.category === selectedCategory);
  }, [selectedCategory]);

  const handleBuyNow = (product) => {
    setSelectedProduct(product);
    setIsBuyModalOpen(true);
  };

  const closeBuyModal = () => {
    setIsBuyModalOpen(false);
    setSelectedProduct(null);
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);
  

  return (
    <div className="products-page">
      <div className="products-hero">
        <div className="container">
          <h1 className="page-title">YANX Wear Collection</h1>
          <p className="page-subtitle">Premium essentials for modern comfort and confidence.</p>
        </div>
      </div>

      <div className="products-content">
        <div className="container">
          <div className="category-filters">
            {categories.map((category) => (
              <button
                key={category}
                type="button"
                className={`filter-btn ${selectedCategory === category ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>

          <div className="products-grid">
            {filteredProducts.map((product) => (
              <ProductCard key={product.id} product={product} onBuyNow={handleBuyNow} />
            ))}
          </div>

          {filteredProducts.length === 0 && (
            <div className="no-products">
              <p>No products found in this category.</p>
            </div>
          )}
        </div>
      </div>

      <BuyNowModal
        isOpen={isBuyModalOpen}
        product={selectedProduct}
        onClose={closeBuyModal}
      />
    </div>
  );
};

export default Products;
